import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { requestUpdateUserGeneral } from "../../../../../redux/actions/user";
import { SolidButton } from "../../../../library/button";
import { Input } from "../../../../library/input";
import { Label } from "../../../../library/label";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const authLoading = useSelector(
    (state) => state.user.fetchUserDetails.loading
  );
  const updateLoading = useSelector(
    (state) => state.user.updateGeneral.loading
  );
  const userInfo = useSelector((state) => state.user.details);
  const [editInfo, setEditInfo] = useState({});

  useEffect(() => {
    if (
      editInfo &&
      Object.keys(editInfo).length === 0 &&
      userInfo &&
      userInfo.firstName
    ) {
      const editObject = {
        address: userInfo.address,
        postalCode: userInfo.postalCode,
        city: userInfo.city,
        country: userInfo.country,
      };
      setEditInfo(editObject);
    }
  }, [userInfo]);

  const clickSave = () => {
    dispatch(
      requestUpdateUserGeneral({
        type: "long",
        info: {
          address: editInfo.address,
          postalCode: editInfo.postalCode.toString().replace(/ /g, ""),
          city: editInfo.city,
          country: editInfo.country,
        },
        user: userInfo.id,
      })
    );
  };

  return (
    <div>
      <div className="account-general-tab-content-container">
        <Row className="account-information-row">
          <Col className="account-information-col">
            <Label version={1} weight="bold">
              Addresse
            </Label>
            {authLoading && (
              <i className="fas fa-circle-notch fa-spin input-loader"></i>
            )}
            <Input
              onChange={(e) =>
                setEditInfo({ ...editInfo, address: e.target.value })
              }
              value={editInfo.address}
              placeholder={!editInfo.address && !authLoading && "Addresse"}
              id="addressInput"
              name="address"
              type="text"
            />
          </Col>
          <Col className="account-information-col">
            <Label version={1} weight="bold">
              Postnummer
            </Label>
            {authLoading && (
              <i className="fas fa-circle-notch fa-spin input-loader"></i>
            )}
            <Input
              format="postal"
              onChange={(e) =>
                setEditInfo({ ...editInfo, postalCode: e.target.value })
              }
              value={editInfo.postalCode}
              placeholder={!editInfo.postalCode && !authLoading && "Postnummer"}
              id="nameInput"
              name="postal"
              type="text"
            />
          </Col>
        </Row>
        <Row className="account-information-row">
          <Col className="account-information-col">
            <Label version={1} weight="bold">
              Poststed
            </Label>
            {authLoading && (
              <i className="fas fa-circle-notch fa-spin input-loader"></i>
            )}
            <Input
              onChange={(e) =>
                setEditInfo({ ...editInfo, city: e.target.value })
              }
              value={editInfo.city}
              placeholder={!editInfo.city && !authLoading && "Poststed"}
              id="cityInput"
              name="city"
              type="text"
            />
          </Col>
          <Col className="account-information-col">
            <Label version={1} weight="bold">
              Land
            </Label>
            {authLoading && (
              <i className="fas fa-circle-notch fa-spin input-loader"></i>
            )}
            <Input
              onChange={(e) =>
                setEditInfo({ ...editInfo, country: e.target.value })
              }
              value={editInfo.country}
              placeholder={!editInfo.country && !authLoading && "Land"}
              id="countryInput"
              name="country"
              type="text"
              autocomplete="false"
            />
          </Col>
        </Row>
      </div>
      <Row className="account-general-bottom-row">
        <Col className="account-general-bottom-col text-right">
          <SolidButton
            color="blue"
            onClick={() => clickSave()}
            icon={
              updateLoading && <i className="fas fa-circle-notch fa-spin"></i>
            }
            title={updateLoading ? "Lagrer endringer.." : "Lagre endringer"}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Index;
